import { render, staticRenderFns } from "./AssetTypeElement.vue?vue&type=template&id=17e39c80&scoped=true&"
import script from "./AssetTypeElement.vue?vue&type=script&lang=ts&"
export * from "./AssetTypeElement.vue?vue&type=script&lang=ts&"
import style0 from "./AssetTypeElement.vue?vue&type=style&index=0&id=17e39c80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17e39c80",
  null
  
)

export default component.exports